module.exports = __webpack_public_path__ + "img/3.5676dcd3.jpg";